import { combineReducers } from 'redux';

import consultaCanais from './consultaCanais/reducer';

export default combineReducers({
	consultaCanais,
});
